export default __webpack_public_path__ + "static/media/dracula-origins.bd0fdecb.jpg";